import artwork from "assets/megawin/design-reference.png";
import React from "react";

// Display the original logo from the supplied design export, without redrawing it.
const MegawinLogo = () => (
  <svg
    className="mw-wordmark"
    viewBox="815 122 300 165"
    role="img"
    aria-label="MegaWin"
  >
    <image href={artwork} width="2913" height="4579" />
  </svg>
);

export default MegawinLogo;
